<!-- FORM -->
<div class="alert alert-success" *ngIf="alertSuccess">
  BPG saved successfully!
</div>
<div class="alert alert-success" *ngIf="alertUpdate">
  BPG updated successfully!
</div>
<div class="alert alert-danger" *ngIf="alertFailure">{{errorMessage}}
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>

<form (ngSubmit)="onSubmit()" name="form" #myForm="ngForm">

  <div class="heading-div">
    <h5>CREATE BPG</h5>
  </div>

  <div class="main-section">
    <div class="form-group">
      <label for="bpgName">BPG Name<span class="star"> *</span></label>
      <input type="text" class="form-control" id="bpgName" placeholder="Enter BPG name" required pattern=".*\S+.*"
        name="bpgName" maxlength="100" [(ngModel)]="bpgName" required>
    </div>

    <div class="form-group">
      <label for="bpgDesc">Description
        <label class="validation-error-message" *ngIf="bpgDesc != null && bpgDesc.length>=1000">
          Only a maximum of 1000 characters are allowed
        </label>
      </label>

      <div class="ckeditor-style val-margin">
        <ckeditor [(ngModel)]="bpgDesc" id="bpgDesc" #myckeditor="ngModel" name="bpgDesc" maxlength="1000"
          [config]="removeToolbar" [readonly]="false" debounce="500" debounce="500">
        </ckeditor>
      </div>
      <!-- <textarea class="form-control" id="bpgDesc" name="bpgDesc" placeholder="Enter BPG description" maxlength="1000" [(ngModel)]="bpgDesc"></textarea> -->
    </div>
  </div>

  <input type="text" class="form-control" name="id" [(ngModel)]="bpgId" style="display: none">

  <div class="btn-div">
    <button type="submit" class="btn btn-danger" *ngIf="editandSavebtn ==false && savebtn == true"
      [disabled]="!myForm.valid" data-toggle="modal" data-target="#myModal">SAVE</button>
    <button type="submit" class="btn btn-danger" *ngIf="editandSavebtn ==true && savebtn == false"
      [disabled]="!myForm.valid" data-toggle="modal" data-target="#myModal">SAVE
      AND UPDATE</button>

    <button type="button" class="btn btn-danger" (click)="resetBpg()" data-toggle="modal"
      data-target="#myModal">RESET</button>
  </div>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
</form>


<!--table-->

<div class="outer-div">
  <div class="searchBox">
    <label for="search">Search</label>
    <input type="text" class="form-control" id="search" maxlength="50" placeholder="Keywords here"
      [(ngModel)]="searchKey" (keyup.enter)="searchMe()">
  </div>
</div>

<p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div id="tabledemo1" *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col" (click)="sortMe('bpgName')">BPG Name <span class="sortupdown"><i id="bpgName1"
                class="fa fa-sort-up"></i><i id="bpgName2" class="fa fa-sort-down"></i></span></th>
          <th scope="col">Description</th>
          <th scope="col" class="col-display">Created By </th>
          <th scope="col" class="col-display">BpgId </th>
          <th scope="col" class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of bpgData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <!-- <td>{{data.bpgName}}</td>
          <td>{{data.bpgDesc}}</td> -->
          <td><span [innerHtml]="data.bpgName"></span></td>
          <td><span [innerHtml]="data.bpgDesc"></span></td>

          <td class="col-display">{{data.createdBy}}</td>
          <td class="col-display">{{data.bpgId}}</td>
          <td>
            <a id="edit{{i}}" (click)="edit(data,i)" class="edit-delete"><img src="assets/images/edit.png" class="image" alt="Angular Logo"
                title="Edit"></a>
            <a class="edit-delete" (click)="deleteBpg(data)" style="display: none">Delete</a>
          </td>
        </tr>

      </tbody>
    </table>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>